import { z } from 'zod';

/**
 * Motivo de cancelamento atribuído pelo super-admin **após** o
 * cancelamento ter ocorrido. Usado pelo dashboard /churn (Sprint
 * 4.10) para tagear cada audit `TENANT_SUSPENDED` com a categoria
 * que melhor descreve o caso.
 */
export const CancellationReasonSchema = z.enum([
  'USER_REQUEST',
  'PAYMENT_FAILED',
  'INACTIVITY',
  'UNKNOWN',
]);
export type CancellationReason = z.infer<typeof CancellationReasonSchema>;
export const ALL_CANCELLATION_REASONS = CancellationReasonSchema.options;

/**
 * Input da callable `categorizeChurnReason` (super-admin) — taggeia o
 * evento de auditoria `TENANT_SUSPENDED` (`/audit/{auditId}`) com o motivo
 * de cancelamento escolhido no dashboard /churn.
 *
 * A categorização **não** pode mais ser feita por escrita direta no
 * Firestore a partir do cliente: (a) o doc de audit é read-only nas Rules;
 * (b) `cancellationCategorizedAt` precisa ser server timestamp, nunca o
 * clock do cliente. Por isso passa por callable dedicada.
 */
export const CategorizeChurnReasonInputSchema = z.object({
  auditId: z.string().min(1),
  reason: CancellationReasonSchema,
});
export type CategorizeChurnReasonInput = z.infer<
  typeof CategorizeChurnReasonInputSchema
>;
